import React from 'react';
import Button from '../../components/ui/Button';
import { formatMoney, formatDate } from '../../utils/formatters';
import './OrdenCompraDetalle.css';

const estadoLabels = {
    borrador: 'Borrador',
    pendiente: 'Pendiente',
    aprobada: 'Aprobada',
    recibida_parcial: 'Parcial',
    recibida: 'Recibida',
    cancelada: 'Cancelada'
};

const OrdenCompraDetalle = ({
    orden,
    loading = false,
    onClose,
    actions = [],
    showRecibido = false
}) => {
    if (loading) {
        return (
            <div className="orden-detalle-modal">
                <div className="loading-state">
                    <div className="loading-spinner"></div>
                    <p>Cargando detalle...</p>
                </div>
            </div>
        );
    }

    if (!orden) {
        return null;
    }

    return (
        <div className="orden-detalle-modal">
            {/* Header con información general */}
            <div className="detalle-header">
                <div className="detalle-info-grid">
                    <div className="detalle-info-item">
                        <span className="info-label">Folio</span>
                        <span className="info-value folio">{orden.folio}</span>
                    </div>
                    <div className="detalle-info-item">
                        <span className="info-label">Proveedor</span>
                        <span className="info-value">{orden.proveedor_nombre}</span>
                    </div>
                    <div className="detalle-info-item">
                        <span className="info-label">Fecha Creación</span>
                        <span className="info-value">{formatDate(orden.fecha_creacion)}</span>
                    </div>
                    {orden.fecha_recepcion && (
                        <div className="detalle-info-item">
                            <span className="info-label">Fecha Recepción</span>
                            <span className="info-value">{formatDate(orden.fecha_recepcion)}</span>
                        </div>
                    )}
                    <div className="detalle-info-item">
                        <span className="info-label">Estado</span>
                        <span className={`estado-badge ${orden.estado}`}>
                            {estadoLabels[orden.estado] || orden.estado}
                        </span>
                    </div>
                    {(orden.estado === 'recibida' || orden.estado === 'recibida_parcial') && (
                        <div className="detalle-info-item">
                            <span className="info-label">Pago</span>
                            <span className={`pago-badge ${orden.estado_pago === 'pagada' ? 'pagada' : 'pendiente'}`}>
                                {orden.estado_pago === 'pagada' ? 'Pagada' : 'Pendiente'}
                            </span>
                        </div>
                    )}
                </div>

                {/* Información de usuarios */}
                <div className="detalle-usuarios">
                    <div className="usuario-item">
                        <span className="usuario-label">Generada por:</span>
                        <span className="usuario-value">{orden.usuario_nombre || '-'}</span>
                    </div>
                    <div className="usuario-item">
                        <span className="usuario-label">Aprobada por:</span>
                        <span className="usuario-value">{orden.aprobador_nombre || '-'}</span>
                    </div>
                    <div className="usuario-item">
                        <span className="usuario-label">Recibida por:</span>
                        <span className="usuario-value">{orden.receptor_nombre || '-'}</span>
                    </div>
                </div>

                {/* Notas */}
                {orden.notas && (
                    <div className="detalle-notas">
                        <span className="info-label">Notas:</span>
                        <p>{orden.notas}</p>
                    </div>
                )}
            </div>

            {/* Tabla de productos */}
            <div className="detalle-productos">
                <h4>Productos</h4>
                <table className="detalle-table">
                    <thead>
                        <tr>
                            <th>Producto</th>
                            <th className="text-center">Cantidad</th>
                            {showRecibido && <th className="text-center">Recibido</th>}
                            <th className="text-right">Precio Unit.</th>
                            <th className="text-right">Subtotal</th>
                        </tr>
                    </thead>
                    <tbody>
                        {orden.detalles?.map((detalle, index) => (
                            <tr key={index}>
                                <td>{detalle.producto_nombre}</td>
                                <td className="text-center">{detalle.cantidad}</td>
                                {showRecibido && (
                                    <td className="text-center">{detalle.cantidad_recibida || 0}</td>
                                )}
                                <td className="text-right">{formatMoney(detalle.precio_unitario)}</td>
                                <td className="text-right">{formatMoney(detalle.subtotal)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Totales */}
            <div className="detalle-totales">
                <div className="total-row">
                    <span>Subtotal:</span>
                    <span>{formatMoney(orden.subtotal)}</span>
                </div>
                {orden.impuesto > 0 && (
                    <div className="total-row">
                        <span>Impuesto:</span>
                        <span>{formatMoney(orden.impuesto)}</span>
                    </div>
                )}
                <div className="total-row total-final">
                    <span>Total:</span>
                    <span>{formatMoney(orden.total)}</span>
                </div>
            </div>

            {/* Acciones */}
            <div className="detalle-actions">
                <Button variant="secondary" onClick={onClose}>
                    Cerrar
                </Button>
                {actions.map((action, index) => (
                    <Button
                        key={index}
                        variant={action.variant || 'primary'}
                        onClick={action.onClick}
                        disabled={action.disabled}
                    >
                        {action.icon && <action.icon size={18} />}
                        {action.label}
                    </Button>
                ))}
            </div>
        </div>
    );
};

export default OrdenCompraDetalle;
